<template>
    <div v-if="isreadshow">
        <my-search @search="searchHandler" v-model="pgData" title-placeholder="标段名称/标段编号">
            <el-form-item slot="time">

            </el-form-item>
            <template slot="btn">
                <el-button type="success" icon="el-icon-coordinate" @click="signature()">在线签章</el-button>
                <el-button type="success" icon="el-icon-plus" @click="add()">添加</el-button>
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段名称" prop="bdname" min-width="220"></el-table-column>
            <el-table-column label="标段编码" prop="bdcode" min-width="220"></el-table-column>
            <el-table-column label="单位名称" prop="zbdwname" min-width="160"></el-table-column>
            <el-table-column label="通知类型" prop="typename" min-width="160"></el-table-column>
            <el-table-column label="中标价格" prop="zbjg" min-width="160">
                <template slot-scope="scope">
                    <div v-if="scope.row.bjlx==='1'||scope.row.bjlx===''||scope.row.bjlx===null||scope.row.bjlx===undefined">
                        {{scope.row.zbjg}}{{scope.row.jgdwname}}{{scope.row.bzname}}                       
                    </div>
                    <div v-else>
                        {{scope.row.zbbj}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="发出时间" prop="fctime" min-width="160"></el-table-column>
            <el-table-column label="状态" min-width="160" v-if="type=='xt'||type=='common'">
                <template slot-scope="scope">
                    <my-tag type="primary" v-if="scope.row.shbj==='1'">已提交待内部审核</my-tag>
                    <my-tag type="warning" v-if="scope.row.shbj==='0'">未提交</my-tag>
                    <my-tag type="success" v-if="scope.row.shbj==='9'">已发布</my-tag>
                    <div v-if="scope.row.shbj==='3'">
                        <my-tag  type="danger">退回</my-tag>
                    </div>
                    <div v-if="scope.row.shbj==='6'">
                        <my-tag type="primary">待交易中心审核</my-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="交易中心" min-width="160" v-if="type=='zc'||type=='xt'">
                <template slot-scope="scope">
                    <template v-if="scope.row.processflag">
                        <jyzx-state :data="scope.row"></jyzx-state>
                        
                        <push-type 
                            :column="scope.row" 
                            :pushPage="'zbjgtzs'" 
                            :primaryKey="scope.row.tzscode"
                            :procode="getQuery('zbprocode')">
                        </push-type>
                    </template>
                    <template v-else>
                        <!--政采-->
                        <template v-if="type=='zc'&&(scope.row.shbj=='9'||scope.row.shbj=='6')">
                            <template v-if="scope.row.extstr1=='1'">
                                <my-tag type="success" v-if="scope.row.xtts==='1'">已发布</my-tag>
                                <my-tag type="warning" v-else>待推送</my-tag>
                            </template>
                            <template v-else>
                                <my-tag type="primary">{{scope.row.extstr2}}无需推送</my-tag>
                            </template>
                        </template>
                        <!--邢台-->
                        <template v-if="type=='xt'">
                            <my-tag type="success" v-if="scope.row.xtts==='1'">已发布</my-tag>
                            <my-tag type="warning" v-else>待推送</my-tag>
                        </template>
                        
                    </template>
                    
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" min-width="160">
                <template slot-scope="scope">
                    <div v-if="scope.row.shbj==='0'||scope.row.shbj==='3'">
                        <my-btn type="edit" @click="edit(scope.row.tzscode)">修改</my-btn>
                        <my-btn type="del" @click="del(scope.row.tzscode)">删除</my-btn>
                    </div>
                    <div v-else>
                        <my-btn type="detail" @click="show(scope.row.tzscode)">查看</my-btn>
                    </div>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/list.json`"></my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import JyzxState from '@views/bidding/components/jyzx-state'
import PushType from '@/components-sys/push-type'
export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {
        PushType,JyzxState
    },
    data() {
        return{
            pgData:{
                zbprocode:'',
                sortname : 'addtime',              
            },
            isreadshow:true,
            tableData:[],
            model:{},
            type:'xt',
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        //删除
        del:function(tzscode){
            var that=this;         
            that.$post(`${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/del.json`,{tzscode:tzscode}, (data, res) => {
                ShowMsg('删除成功', 'success');
                that.reload();
            }); 
        },
        //详情
        show:function(tzscode){
            this.goto({
                path:'./detail',
                query:{
                    tzscode:tzscode,
                    type:this.type
                }
            });
        },
        //添加
        add:function(){
            this.goto({
                path:'./form',
                query:{
                    zbprocode:this.pgData.zbprocode,
                    type:this.type
                }
            });
        },
        //修改
        edit:function(tzscode){
            this.goto({
                path:'./form',
                query:{
                    tzscode:tzscode,
                    zbprocode:this.pgData.zbprocode,
                    type:this.type
                }
            });
        },
        // 在线签章
        signature(){
            this.goto({
                path:'./signatureList',
                query:{
                    zbprocode:this.pgData.zbprocode,
                    type:this.type
                }
            });
        }
    },
    created() {
        var that = this
        if(that.$route.query.zbprocode!=undefined){
            that.pgData.zbprocode=that.$route.query.zbprocode
        }
        that.jspInit(`${that.getGetters('mngUrl')}/DingBiao/ZbJgTzs/xingtai/listinit.json`,{
            zbprocode:that.getQuery('zbprocode'),
        }, data => {
            that.model = data.model
            if(that.model.ext3){
                that.type = 'zc'
            }else{
                if(that.getQuery('isXt')){
                    that.type = 'xt'
                }else{
                    that.type = 'common'
                }
            }
            console.log(that.type)
        });
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
